import { FileProtectOutlined, EditFilled,UserSwitchOutlined } from '@ant-design/icons';

const icons = { FileProtectOutlined, EditFilled,UserSwitchOutlined };
const roles = [0,1,2];

const distributor = {
  id: 'group-distributor',
  title: 'Dealer',
  type: 'collapse',
  icon: icons.UserSwitchOutlined,
  roles,
  children: [
    {
      id: 'DistributorRequest',
      title: 'Dealer Request',
      type: 'item',
      url: '/distributor-request',
      icon: icons.EditFilled,
      breadcrumbs: false,
      roles
    },
    {
      id: 'DistributorRequestAdmin',
      title: 'Dealer Approval',
      type: 'item',
      url: '/distributor-request-admin',
      icon: icons.EditFilled,
      breadcrumbs: false,
      roles
    }
  ]
};

export default distributor;